export enum RollAs {
  INDIVIDUAL = 'INDIVIDUAL',
  TOGETHER = 'TOGETHER',
}

export const ROLL_AS = [
  { id: RollAs.INDIVIDUAL, displayValue: 'Individual' },
  { id: RollAs.TOGETHER, displayValue: 'Together' },
];
